import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Location} from '@angular/common';
import {TokenStorage} from '@foo/foo-framework';
import {Direction} from '@angular/cdk/bidi';

@Component({
    selector: 'app-unauth-home',
    templateUrl: './unauth-pages.component.html',
    styleUrls: ['./unauth-pages.component.scss'],
    standalone: false
})
export class UnauthPagesComponent implements OnInit {

    configuration = window['configuration'] ? JSON.parse(window['configuration']) : null;
    logoSource = this.configuration && this.configuration['logo'] ? this.configuration['logo'] :
        this.configuration && this.configuration['login_logo'] ? this.configuration['login_logo'] : null;

    isClosed = false;
    curLang: string;
    logo: any;
    @Output() LangChangedEvent = new EventEmitter<string>();
    direction: Direction | "auto" = this.translate.instant("general.dir") as Direction | "auto";

    constructor(private translate: TranslateService, private location: Location, private tokenStorage: TokenStorage) {

        if (this.tokenStorage.getCurrentLanguage()) {
            this.curLang = this.tokenStorage.getCurrentLanguage();
            translate.setDefaultLang(this.tokenStorage.getCurrentLanguage());
        } else {
            this.tokenStorage.setCurrentLanguage("en");
            translate.setDefaultLang('en');
            this.curLang = "en";
        }
    }

    ngOnInit(): void {
        const config = JSON.parse(this.tokenStorage.getWebConfig());
        this.logo = config.logo;
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.direction = this.translate.instant("general.dir") as Direction | "auto";
        });
    }

    changeLanguage() {
        var language = "en";
        if (this.tokenStorage.getCurrentLanguage() == "en") {
            language = "ar";
        }
        this.LangChangedEvent.emit(language);
        this.translate.use(language);
        this.tokenStorage.setCurrentLanguage(language);
        this.curLang = language;
    }

    useLanguage(language: any) {
        this.LangChangedEvent.emit(language);
        this.translate.use(language);
        this.tokenStorage.setCurrentLanguage(language);
        this.curLang = language;
    }

    goBack() {
        this.location.back();
    }
}
